import { render, staticRenderFns } from "./Game1.vue?vue&type=template&id=07fafe5d&scoped=true&"
import script from "./Game1.vue?vue&type=script&lang=js&"
export * from "./Game1.vue?vue&type=script&lang=js&"
import style0 from "./Game1.vue?vue&type=style&index=0&id=07fafe5d&prod&lang=scss&scoped=true&"
import style1 from "./Game1.vue?vue&type=style&index=1&id=07fafe5d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fafe5d",
  null
  
)

export default component.exports